import React from "react";

export function TestComponent(props) {
  return (
    <section className="user-dashboard">
      <h1>Test Component</h1>
      <h1>Testing Repo created from template</h1>
    </section>
  );
}
